import { ref, reactive, computed } from 'vue';
import store from '@/store';
import { config } from '@/config.js';

export function useContactForm() {
    const formData = reactive({
        email: '',
        subject: '',
        message: ''
    });

    const isSending = ref(false);
    const isSuccess = ref(false);

    const footer = computed(() => store.getters.getFooter);

    const submitMessage = async() => {
        if (isSending.value) return;

        isSending.value = true;

        const payload = {
            ...formData
        };

        try {
            await store.dispatch(config.getVuexAlias('front.ayuda'), payload);
            isSuccess.value = true;
            return true;
        } catch (error) {
            console.error(error);
            throw error;
        } finally {
            isSending.value = false;
        }
    };

    return {
        formData,
        isSending,
        isSuccess,
        footer,
        submitMessage
    };
}
